import React from "react";
import { BRAND, whatsappLink } from "../mock/mock";

const WhatsAppIcon = ({ className = "h-5 w-5" }) => (
  <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className={className} fill="currentColor" aria-hidden="true">
    <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39-.65 0-3.917-2.174-4.83-5.298-.006-.045-.078-.36-.078-.404 0-.523 1.331-.775 1.331-1.294 0-.32-1.056-2.522-1.365-2.902-.16-.196-.363-.276-.581-.276-.221 0-.435.09-.612.201-.472.298-1.535 1.34-1.535 3.153 0 .96.336 1.978 1.05 3.036 1.994 2.985 4.323 5.104 8.036 6.03.638.16 1.098.24 1.484.24.99 0 2.164-.68 2.514-1.663.35-.985.35-1.83.24-1.99-.11-.16-.4-.24-.812-.446-.413-.204-2.443-1.203-2.815-1.336-.372-.132-.643-.198-.912-.198z"/>
    <path d="M16.001 0C7.164 0 .003 7.159.003 16c0 2.821.735 5.464 2.02 7.75L0 32l8.464-2.005a15.94 15.94 0 007.537 1.907c8.837 0 15.999-7.159 15.999-16C31.999 7.159 24.838 0 16.001 0zm0 29.259a13.24 13.24 0 01-6.755-1.844l-4.836 1.146 1.171-4.717A13.229 13.229 0 012.741 16C2.741 8.673 8.673 2.741 16 2.741S29.258 8.673 29.258 16 23.328 29.259 16.001 29.259z"/>
  </svg>
);

const WhatsAppFloat = () => {
  const href = whatsappLink("Hello Agrawal Rich Dry Fruits, I'd like to place an order / enquiry.");
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed z-40 bottom-5 right-5 h-14 w-14 rounded-full bg-[#25D366] text-white shadow-lg flex items-center justify-center hover:bg-[#1ebe5b] hover:scale-105 transition-all"
    >
      <span className="absolute inset-0 rounded-full animate-ping bg-[#25D366]/40" />
      <WhatsAppIcon className="h-7 w-7 relative" />
    </a>
  );
};

export { WhatsAppIcon };
export default WhatsAppFloat;
